import { GameApi as API_URL } from '../api/config';

export async function savePlayerInfo(playerData) {
  try {
    const response = await fetch(`${API_URL}?action=savePlayer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(playerData),
    });
    if (!response.ok) throw new Error('Failed to save player info');
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error saving player info:', error);
    return null;
  }
}

export async function getQuestions() {
  try {
    const response = await fetch(API_URL);
    if (!response.ok) throw new Error('Failed to fetch questions');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching questions:', error);
    return [];
  }
}

export async function savePlayerResult({ player_id, result }) {
  try {
    console.log("Sending result to API:", { player_id, result }); // Debug line
    const response = await fetch(`${API_URL}?action=saveResult`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ player_id, result }),
    });
    if (!response.ok) throw new Error('Failed to save result');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error saving result:', error);
    return null;
  }
}
export async function getPlayerByEmail(email) {
  try {
    const response = await fetch(`${API_URL}?action=getPlayerByEmail&email=${encodeURIComponent(email)}`);
    if (!response.ok) throw new Error('Failed to fetch player by email');
    const player = await response.json();
    return player;
  } catch (err) {
    console.error("Error fetching player by email:", err);
    return null;
  }
}